import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import Swiper from 'swiper'
import Swiper from 'swiper/dist/js/swiper.js'
import cx from 'classnames'

import ProgressBar from './ProgressBar'

// import '../../shared/styles/_swiper.scss'


const params = {
  resistance: false,
  speed: 600,
  loop: false
}

export default class ReactSwiper extends Component {

  state = {
    currentSlide: 0,
    progress: 0
  }

  childrenQuantity = 0
  progressSingleLength = 0
  currentSlide = 0
  prevSlide = 0
  isTransitionStarted = false

  componentDidMount () {
    this.initSwiper()

    this.childrenQuantity = this.props.children.length
    this.progressSingleLength = 1 / (this.childrenQuantity - 1)
  }

  componentDidUpdate () {
    this.swiper.update()
  }

  componentWillUnmount () {
    this.swiper.destroy(true, true)
    delete this.swiper
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.children !== this.props.children) return true
    if (nextProps.slide !== this.state.currentSlide) return true
    if (nextState.progress !== this.state.progress) return true
    return false
  }

  componentWillReceiveProps (nextProps) {
    let { slide } = nextProps

    if (slide !== null && slide !== this.state.currentSlide) {
      this.setState({ currentSlide: slide }, () => this.swiper.slideTo(slide))
    }

    this.swiper.update()
  }

  initSwiper () {
    if (!this.containerNode) return false
    this.swiper = Swiper(this.containerNode, {
      ...params,
      initialSlide: this.state.currentSlide,
      onProgress: (swiper, progress) => {
        if (!isNaN(progress) && !this.isTransitionStarted) {
          // console.log('onProgress', progress)
          this.setProgress(progress)
        }
      },
      onTransitionStart: (swiper) => {
        if (swiper) {
          // console.log('onTransitionStart', swiper)
          this.isTransitionStarted = true
          if (this.currentSlide !== swiper.activeIndex) { // Swap currentSlide and prevSlide if swipe guest was "canceled"
            this.prevSlide = this.currentSlide
            this.currentSlide = swiper.activeIndex
          }

          this.currentSlide = swiper.activeIndex
          this.forceUpdate()
        }
      },
      onTransitionEnd: (swiper) => {
        if (swiper) {
          this.isTransitionStarted = false
          this.setProgress(swiper.progress)
          this.props.onTransitionEnd(swiper)
        }
      },
      onTouchStart: (swiper) => { // If user touches screen, cancel current transition if any
        this.isTransitionStarted = false
        this.setProgress(swiper.progress)
      },
      onSlideChangeEnd: () => {
        this.forceUpdate()
      }
    })
  }

  setProgress (progress) { // Sets current & previous slide number according to Swiper progress
    for (let i = 0; i < this.childrenQuantity; i++) {
      if ((progress - i * this.progressSingleLength) < 0) {
        this.prevSlide = i - 1
        break
      }
    }

    if (this.swiper) {
      if (this.swiper.touches.diff > 0) {
        this.prevSlide++
        this.currentSlide = this.prevSlide - 1
      } else {
        this.currentSlide = this.prevSlide + 1
      }

      if (this.state.progress !== progress) {
        this.setState({ progress })
      }
    }
  }

  getProgressOfSlide (slide) {
    let progress

    if (slide === this.currentSlide) {
      if (this.currentSlide > this.prevSlide) {
        progress = this.state.progress / this.progressSingleLength - this.currentSlide + 1
      } else {
        progress = -(this.state.progress / this.progressSingleLength - this.currentSlide - 1)
      }
    } else if (slide === this.prevSlide) {
      if (this.currentSlide > this.prevSlide) {
        progress = -(this.state.progress / this.progressSingleLength - this.prevSlide)
      } else {
        progress = this.state.progress / this.progressSingleLength - this.prevSlide
      }
    }

    if (progress && this.isTransitionStarted) {
      return { duration: (progress > 0 ? 1 - progress : -1 + progress) * params.speed }
    } else {
      return progress
    }
  }

  render () {
    return (
      <div className='swiper-container fi_scene' ref={ref => (this.containerNode = ref)}>
        <div className='swiper-wrapper'>
          {this.props.children.map(
            (e, index) => React.cloneElement(e, {
              className: cx('swiper-slide', e.props.className),
              progress: this.getProgressOfSlide(index)
            })
          )}
        </div>
        <ProgressBar
          progress={this.swiper && (Math.round(this.swiper.progress * (this.childrenQuantity - 1)) / (this.childrenQuantity - 2))}
          key={108}
        />
      </div>
    )
  }

  static propTypes = {
    slide: PropTypes.number,
    onTransitionEnd: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/Swiper.js